import { useState, useRef, Fragment } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";

import edit from "../../edit.png";
import trash from "../../trash.png";
import gonext from "../../gonext.png";

import PlTitle from "../../elements/PlTitle";
import InputPagger from "../../helpers/InputPagger";
import InputComboGrupa from "../../helpers/InputComboGrupa";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputLegend from "../../helpers/InputLegend";
import InputCombo from "../../helpers/InputCombo";

import ContractNew from "./ContractNew";
import ContractEdit from "./ContractEdit";

import ContractMassStawka from "./ContractMassStawka";
import ContractMassStawkaDel from "./ContractMassStawkaDel";
import ContractMassStawkaData from "./ContractMassStawkaData";
import ContractMassFields from "./ContractMassFileds";
import InputDate from "../../helpers/InputDate";
import InputComboStawkiWyzMulti from "../../helpers/InputComboStawkiWyzMulti";
import SortBy from "../../helpers/SortBy";
import AppContext from "../../AppContext";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Xlsx from "../../exporter/Xlsx";
import Print from "../../exporter/Print";


function Contract(props)
{

    const tabRef = useRef(0);
    const tab2Ref = useRef(0);

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    
    const [filterParam, setFilterParam] = useState({
        d_imie_nazwisko: props.mainView.readFilter('d_imie_nazwisko',''), 
      
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'), 

        data_rozpoczecia_od: props.mainView.readFilter('data_rozpoczecia_od',''), 
        data_rozpoczecia_do: props.mainView.readFilter('data_rozpoczecia_do',''), 

        data_zakonczenia_od: props.mainView.readFilter('data_zakonczenia_od',''), 
        data_zakonczenia_do: props.mainView.readFilter('data_zakonczenia_do',''), 

        okres_do_wystawienia_od: props.mainView.readFilter('okres_do_wystawienia_od',''), 
        okres_do_wystawienia_do: props.mainView.readFilter('okres_do_wystawienia_do',''), 

        zawiera_stawke: '',
        niezawiera_stawki: '',       

        stan_umowy: '1',


        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

        limit: 50,
        page: 1,
        pages: 1,
        show: true, 
    });
    const [tab, setTab] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);

    const [gr, setGr] = useState([]);
    const fetchGr = (fTab) => {   setGr(fTab);  }
    

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );


       
    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });
}

    const onBack = (e) => {

        setView({...view, ["v"]:"list", ["id"]:"-1" }); 
        getTab();
        
    }


   var itemsStanyUmowy = [
    {
        v: '_x_',
        title: ' - - - '
    },
    {
        v: '1',
        title: 'Umowa zawarta, generuj rozliczenia'
    },
    {
        v: '2',
        title: 'Umowa rozwiązana/zakończona'
    },
    {
        v: '3',
        title: 'Umowa czeka na podpis'
    },
];




const [legend, setLegend] = useState([
    {
        cls:'color_deleted',
        title: 'umowa nieaktywna',
        filter: {  filed: "stan_umowy", set: "2",  typ: "combo"  },
    },
]);




//-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = 0;

    if(e.target.checked) selected = 1;

    for(var k=0; k<selectedRow.length; k++)
    {
        if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
    }

    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
}

const changeSelectedAll = (e) => {

    var s = selectedRow[0].selected;
    if(s == 1) {  s = 0; } else s = 1;

    for(var k=0; k<selectedRow.length; k++)
        {
          selectedRow[k].selected = s;
        }
    
        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

}


const goCloseConract = (e) =>
{
    var type = e.target.getAttribute('close-type');

    var ids = new Array();

    for(var k=0; k<selectedRow.length; k++)
        {
           if( selectedRow[k].selected == 1)
           {
                ids.push({
                    id: selectedRow[k].id,
                    title: selectedRow[k].title
                });
           }
        }
    

     if(ids.length < 1)     
     {       
        props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dokumentu' ,  "ok"  ,null); 
        return;              
     }


    props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz zakończyć wybrane umowy", "yesno", (option)=>{
          
        ///--------
        if(option == "yes")
        {
                    props.mainView.setProgress(-2);

                    var req = {
                        ids: ids,
                        type: type,
                    }

                    fetch( Config.url + '/rest_v1_calc,umowa_close', {
                        method: 'POST', 
                        body: JSON.stringify(req), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                            '_p_dziecko_id_': props.userData.p_dziecko_id,
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                props.mainView.setProgress(-1);        
                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                }else    
                                {      
                                    props.mainView.showDialog( "Sukces", "Zakończono umów: " + res.result , "ok" , null);                               
                                    getTab();            
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                props.mainView.setProgress(-1);
                    });
        }//koniec yes
        //--------
    } );

}


const addFee = () => {


    var ids = new Array();

    for(var k=0; k<selectedRow.length; k++)
        {
           if( selectedRow[k].selected == 1)
           {
                ids.push({
                    id: selectedRow[k].id,
                    title: selectedRow[k].title
                });
           }
        }
    
        
     if(ids.length < 1)     
     {       
        props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dokumentu' ,  "ok"  ,null); 
        return;              
     }



  setView({
    v:"nowa_stawka",
    id: -1,
  });  

}

const removeFee = () => {
    
    var ids = new Array();

    for(var k=0; k<selectedRow.length; k++)
        {
           if( selectedRow[k].selected == 1)
           {
                ids.push({
                    id: selectedRow[k].id,
                    title: selectedRow[k].title
                });
           }
        }
    
        
     if(ids.length < 1)     
     {       
        props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dokumentu' ,  "ok"  ,null); 
        return;              
     }


    setView({
        v:"usun_stawke",
        id: -1,
      }); 

}

const changeDateFee = () => {
    

    var ids = new Array();

    for(var k=0; k<selectedRow.length; k++)
        {
           if( selectedRow[k].selected == 1)
           {
                ids.push({
                    id: selectedRow[k].id,
                    title: selectedRow[k].title
                });
           }
        }
    
        
     if(ids.length < 1)     
     {       
        props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dokumentu' ,  "ok"  ,null); 
        return;              
     }


    setView({
        v:"zmien_date",
        id: -1,
      }); 

}


const changeDateGen = () => {


    var ids = new Array();

    for(var k=0; k<selectedRow.length; k++)
        {
           if( selectedRow[k].selected == 1)
           {
                ids.push({
                    id: selectedRow[k].id,
                    title: selectedRow[k].title
                });
           }
        }
    
        
     if(ids.length < 1)     
     {       
        props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dokumentu' ,  "ok"  ,null); 
        return;              
     }



  setView({
    v:"data_gen",
    id: -1,
  });  

}


//MASS
//-------------------------------------------------------
//-------------------------------------------------------




        const getTab = () => {
            
        
            props.mainView.setProgress(-2);

        

            fetch( Config.url + '/rest_v1_calc,contracts', {
                method: 'POST', 
                body: JSON.stringify(filterParam), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            setTab(res.result);  

                            var newSelector = [];

                            res.result.forEach( (item) => {
                                newSelector.push({
                                    id: item.id,
                                    title: item.numer_umowy + " ("+item.imie + " " + item.nazwisko +")",
                                    selected: 0,
                                });
                            } )

                            setSelectedRow(newSelector);

                            if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;
        }



        const valChangeListener = (filedName, val, correct, msg) => {

             //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
            
          
            
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        

            props.mainView.writeFilter(filedName, val);            
        }


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }

        const filterView = () => {
            setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
        }


        const filterClear = () => {

            props.mainView.writeFilter('d_imie_nazwisko', '');
            
            props.mainView.writeFilter('p_group_id', '_x_');
            props.mainView.writeFilter('stan_umowy', '1');

            props.mainView.writeFilter('data_rozpoczecia_od', '');
            props.mainView.writeFilter('data_rozpoczecia_do', '');
            props.mainView.writeFilter('data_zakonczenia_od', '');
            props.mainView.writeFilter('data_zakonczenia_do', '');

            props.mainView.writeFilter('okres_do_wystawienia_od', '');
            props.mainView.writeFilter('okres_do_wystawienia_do', '');

            props.mainView.writeFilter('zawiera_stawke', '');
            props.mainView.writeFilter('niezawiera_stawki', '');
       

            setFilterParam({
                d_imie_nazwisko: '', 
                   
                p_grupa_id: '_x_',            

                data_rozpoczecia_od: '',            
                data_rozpoczecia_do: '',   
                data_zakonczenia_od: '',            
                data_zakonczenia_do: '',

                okres_do_wystawienia_od: '',
                okres_do_wystawienia_do: '',

                zawiera_stawke: '',
                niezawiera_stawki: '',

                stan_umowy: '1',    
                
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }

        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }


        const showKid = (e) => {

            var search = e.target.getAttribute("search");
            props.mainView.writeFilter('d_imie_nazwisko', search );

           props.mainView.clickMenu( "kids","kid","" ); 
        }


        if(tab == null)
        {
            setTab([]);
            getTab();
        

            return <div>
                ...
            </div>
        }


        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
            setView( {
                v:'list',
                id: -1
            });
        }


 
      
    if(view.v == 'new')    
    {
        return <ContractNew  userData={props.userData}  mainView={props.mainView} onBack={onBack} />
    }

    if(view.v == 'edit')    
        {
            return <ContractEdit  userData={props.userData}  mainView={props.mainView} onBack={onBack} id={view.id} />
        }

    if(view.v == 'nowa_stawka' )    
    {

        var ids = new Array();

        for(var k=0; k<selectedRow.length; k++)
            {
               if( selectedRow[k].selected == 1)
               {
                    ids.push({
                        id: selectedRow[k].id,
                        title: selectedRow[k].title
                    });
               }
            }         

            return <ContractMassStawka  userData={props.userData}  mainView={props.mainView} onBack={onBack} ids={ids} />
    }


    if(view.v == 'usun_stawke')    
        {
    
            var ids = new Array();
    
            for(var k=0; k<selectedRow.length; k++)
                {
                   if( selectedRow[k].selected == 1)
                   {
                        ids.push({
                            id: selectedRow[k].id,
                            title: selectedRow[k].title
                        });
                   }
                }

                return <ContractMassStawkaDel  userData={props.userData}  mainView={props.mainView} onBack={onBack} ids={ids} />
                 
        }


    if(view.v == 'zmien_date')    
            {
        
                var ids = new Array();
        
                for(var k=0; k<selectedRow.length; k++)
                    {
                       if( selectedRow[k].selected == 1)
                       {
                            ids.push({
                                id: selectedRow[k].id,
                                title: selectedRow[k].title
                            });
                       }
                    }    
                    
                    return <ContractMassStawkaData  userData={props.userData}  mainView={props.mainView} onBack={onBack} ids={ids} />
        }


    if(view.v == 'data_gen')    
            {
        
                var ids = new Array();
        
                for(var k=0; k<selectedRow.length; k++)
                    {
                       if( selectedRow[k].selected == 1)
                       {
                            ids.push({
                                id: selectedRow[k].id,
                                title: selectedRow[k].title
                            });
                       }
                    }    
                    
                    return <ContractMassFields  userData={props.userData}  mainView={props.mainView} onBack={onBack} ids={ids} />
        }








    var zaznaczonych = 0;
    for(var s=0; s<selectedRow.length; s++)
    {
        if(selectedRow[s].selected == 1) zaznaczonych ++;
    }


    var sortList = [
            {column: "data_zawarcia", name: "Data zawarcia"  },
            {column: "data_od", name: "Data rozpoczęcia"  },
            {column: "data_do", name: "Data zakończenia"  },
            {column: "dziecko_nazwisko", name: "Dziecko"  },
    ]



    var titleRaport = "Umowy "; 

    if(filterParam.p_grupa_id != '_x_') 
    {
        for(var p=0; p < gr.length; p++)
        {
            if(gr[p].v == filterParam.p_grupa_id)
            {
                titleRaport += " " + gr[p].title;
                break;
            }
        }
    }else  titleRaport += " wszystkie grupy" ;

  
    document.title = titleRaport;




    return (
        <div className="view_content">
          

            {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
            } 


            {
                    filterParam.show == true  &&
                    <div className="table_filter">

                    <div className="filter_controll">   
                        <label>Grupa: </label>                             
                        <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}  fetchTab={fetchGr}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                    </div> 


                    <div className="filter_controll">   
                                <label>Dziecko: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                   </div>  

          

                    <div className="filter_controll">   
                        <label>Stan umowy: </label>                             
                        <InputCombo  items={itemsStanyUmowy}  userData={props.userData}  mainView={props.mainView}  value={filterParam.stan_umowy}   valChange={valChangeListener} goNext={goNextNew} name="stan_umowy"    />
                    </div> 


                    <div className="filter_controll filter_merge">   
                                <label>Data rozpoczęcia (od dnia / do dnia): </label>      <br/>                       
                                <InputDate   userData={props.userData} value={filterParam.data_rozpoczecia_od}   valChange={valChangeListener} goNext={goNextNew} name="data_rozpoczecia_od" placeholder={"Od dnia: "}   />                                                                  
                                <InputDate   userData={props.userData} value={filterParam.data_rozpoczecia_do}   valChange={valChangeListener} goNext={goNextNew} name="data_rozpoczecia_do" placeholder={"Do dnia: "}   />
                    </div> 

                    <div className="filter_controll filter_merge">   
                                <label>Data zakończenia (od dnia / do dnia): </label>      <br/>                       
                                <InputDate   userData={props.userData} value={filterParam.data_zakonczenia_od}   valChange={valChangeListener} goNext={goNextNew} name="data_zakonczenia_od" placeholder={"Od dnia: "}   />                                                                  
                                <InputDate   userData={props.userData} value={filterParam.data_zakonczenia_do}   valChange={valChangeListener} goNext={goNextNew} name="data_zakonczenia_do" placeholder={"Do dnia: "}   />
                    </div> 


                    <div className="filter_controll filter_merge">   
                                <label>Data następnego rozliczenia  (od dnia / do dnia): </label>      <br/>                       
                                <InputDate   userData={props.userData} value={filterParam.okres_do_wystawienia_od}   valChange={valChangeListener} goNext={goNextNew} name="okres_do_wystawienia_od" placeholder={"Od dnia: "}   />                                                                  
                                <InputDate   userData={props.userData} value={filterParam.okres_do_wystawienia_do}   valChange={valChangeListener} goNext={goNextNew} name="okres_do_wystawienia_do" placeholder={"Do dnia: "}   />
                    </div> 


                                        
                    <div className="filter_controll">   
                        <label>ZAWIERA wszystkie wybrane stawki: </label>                             
                        <InputComboStawkiWyzMulti  value={filterParam.zawiera_stawke}    userData={props.userData}  mainView={props.mainView}    valChange={valChangeListener} goNext={goNextNew} name="zawiera_stawke"    />
                    </div> 


                    <div className="filter_controll">   
                        <label>NIE zawiera żadnej z wybranej stawki: </label>                             
                        <InputComboStawkiWyzMulti  value={filterParam.niezawiera_stawki}    userData={props.userData}  mainView={props.mainView}    valChange={valChangeListener} goNext={goNextNew} name="niezawiera_stawki"    />
                    </div> 


                    <div className="filter_btn">
                                <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                    </div>

            </div>
            } 



           




            <div className="bg_center">


                            <div className="table_widget">
                                    <div className="btn" onClick={changeView} v="new" id="-1"  > nowa umowa</div>

                                    <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                        
                                    <InputLegend items={legend} valChange={valChangeListener}/>

                                        &nbsp; &nbsp;
                                           
                                        <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport  } />   

                                        <Csv tabRef={tab2Ref} title={ titleRaport + ".csv" } />
                                        <Xlsx tabRef={tab2Ref} title={ titleRaport  + ".xlsx" } />
                            
                                        <Print tabRef={tab2Ref}  title={titleRaport} />

                                    <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />

 
                                       
                                        
                            </div>
                           
                            <div className="table_mass">  
                                        <div className="title_mass">Operacje masowe (zaznaczono: {zaznaczonych}) </div>
                                        &nbsp;                                                                   
                                        <span className="btn" close-type="now" onClick={goCloseConract}>Zakończ (teraz)</span>
                                        &nbsp;
                                        <span className="btn" close-type="month" onClick={goCloseConract}>Zakończ (z końcem miesiąca)</span>
                                        &nbsp;
                                        <span className="btn" onClick={addFee}    >Dodaj stawkę</span>
                                        &nbsp;
                                        <span className="btn gohide" onClick={removeFee}  >Usuń stawkę</span>
                                        &nbsp;
                                        <span className="btn" onClick={changeDateFee}  >Zmień okres stawki</span>
                                        &nbsp;
                                        <span className="btn" onClick={changeDateGen}  >Zmień inne elementy</span>
                            </div>
                          


                        <div ref={tabRef} className="gohide">

                                    <h3>{titleRaport}</h3>   

                                       <table className="table" ref={tab2Ref}>
                                        <thead>
                                            <tr className="header">
                                                                        
                                                <td>LP</td>                                                
                                                <td>Numer</td>                                                                                      
                                                <td>Data zawarcia</td>                                                                                      
                                                <td>Dziecko</td>                                                                                    
                                                <td>Data rozpoczęcia</td>                                                                                      
                                                <td>Data zakończenia</td>                                                                                      
                                                <td>Stan umowy</td>                                                                                      
                                                <td>Data następnego rozliczenia</td>                                                                                                                                    
                                                <td>Stawki</td>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                tab.map(  (row, ix) => {

                                                    var st = '';
                                                    if(row.stan_umowy == '1') st = 'Umowa zawarta, generuj rozliczenia';
                                                    if(row.stan_umowy == '2') st = 'Umowa rozwiązana/zakończona';
                                                    if(row.stan_umowy == '3') st = 'Umowa czeka na podpis';


                                                    var cls = "";
                                                    if(row.stan_umowy == '2') cls = "color_deleted";


                                          


                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return  <tr className={rowStyle+  cls} key={ix}>     

                                              

                                                    <td className="gocenter">{ix+1}</td>                                                  
                                                    <td className="gocenter link_normal"  >{row.numer_umowy}</td>                                                                                      
                                                    <td className="gocenter">{row.data_zawarcia}</td> 
                                                    <td>{row.nazwisko  + " " + row.imie }   </td> 
                                                    <td className="gocenter">{row.data_od}</td>
                                                    <td className="gocenter">{row.data_do}</td>         
                                                    <td className="gocenter">{st}</td>  
                                                    <td className="gocenter">{row.okres_do_wystawienia}</td>                       
                                                      <td className="goleft" >                                                                                                                                                                                                                                                                                                                                                                          
                                                                                 
                                                                                    {
                                                                                        row.stawki.map(  (st, stInx) => {
                                                                                            return <Fragment>
                                                                                                {st.nazwa_stawki} - { parseFloat(st.kwota_netto).toFixed(2) }, 
                                                                                            </Fragment>
                                                                                        } )
                                                                                    }
                                                                               
                                                                           
                                                                    
                                                    </td>
                                                  
                                                  
                                                </tr>

                                                } )
                                            }

                                        </tbody>
                             </table>
                        </div>




                   <div className="scorll_x">         
                            <table className="table"  >
                                        <thead>
                                            <tr className="header">
                                                <td className="link_normal td_left" onClick={changeSelectedAll}>Z</td>                                                
                                                <td>LP</td>
                                                <td>V</td>
                                                <td>Numer</td>                                                                                      
                                                <td>Data zawarcia</td>                                                                                      
                                                <td>Dziecko</td>                                                                                    
                                                <td>Data rozpoczęcia</td>                                                                                      
                                                <td>Data zakończenia</td>                                                                                      
                                                <td>Stan umowy</td>                                                                                      
                                                <td className="td_right">Data następnego rozliczenia</td>                                                                                      
                                                <td className="td_option"></td>                                                                                  
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                tab.map(  (row, ix) => {

                                                    var st = '';
                                                    if(row.stan_umowy == '1') st = 'Umowa zawarta, generuj rozliczenia';
                                                    if(row.stan_umowy == '2') st = 'Umowa rozwiązana/zakończona';
                                                    if(row.stan_umowy == '3') st = 'Umowa czeka na podpis';


                                                    var cls = "";
                                                    if(row.stan_umowy == '2') cls = "color_deleted";


                                                    var isChecked = "";

                                                    for(var s=0; s<selectedRow.length; s++)
                                                        {
                                                            if( selectedRow[s].id == row.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                        }


                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return  <tr className={rowStyle+  cls} key={ix}>     

                                                    <td className="gocenter">
                                                        <input type="checkbox" atr-id={row.id} onChange={changeSelected} checked={isChecked} />
                                                    </td>

                                                    <td className="gocenter">{ix+1}</td>
                                                    <td className="gocenter txtcloud" >      
                                                                     <span className="txt_square" onClick={changeView} v="edit" id={row.id}></span>
                                                                     <span className="info_content">
                                                                              <span className="info_cloud shadowx"  >         
                                                                                <span className="info_title">{row.numer_umowy}</span>                                                                                         
                                                                                 <ul>
                                                                                    {
                                                                                        row.stawki.map(  (st, stInx) => {
                                                                                            return <li>
                                                                                                {st.nazwa_stawki},   { parseFloat(st.kwota_netto).toFixed(2) }
                                                                                            </li>
                                                                                        } )
                                                                                    }
                                                                                 </ul>
                                                                              </span>
                                                                     </span> 
                                                    </td>
                                                    <td className="gocenter link_normal" onClick={changeView} v="edit" id={row.id} >{row.numer_umowy}</td>                                                                                      
                                                    <td className="gocenter">{row.data_zawarcia}</td> 
                                                    <td>{row.nazwisko  + " " + row.imie } <img  src={gonext} onClick={showKid} search={row.nazwisko  + " " + row.imie} className="link_normal small_tip_img"  title="Idź do dziecka" /> </td> 
                                                    <td className="gocenter">{row.data_od}</td>
                                                    <td className="gocenter">{row.data_do}</td>         
                                                    <td className="gocenter">{st}</td>  
                                                    <td className="gocenter">{row.okres_do_wystawienia}</td>                       
                                                    <td className="td_btn_option"> <img className="ibtn" src={edit} title="Zmień dane"  onClick={changeView} v="edit" id={row.id} /> </td>
                                             
                                                  
                                                </tr>

                                                } )
                                            }

                                        </tbody>
                             </table>
                   </div>


            </div>





        </div>
    );

}

export default Contract;